import { isConnectedAccount } from 'owa-accounts-store';
import { getConnectedAccountHeaders } from 'owa-connected-account-headers';
import { createRestApiRequestHeadersWithFetchOptions } from './createRestApiRequestHeadersWithFetchOptions';

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS2322 (8,45): Type 'null' is not assignable to type 'string'.
// @ts-ignore
export function createRestApiRequestHeaders(userIdentity: string = null): Promise<void | {}> {
    if (isConnectedAccount(userIdentity)) {
        return createRestApiRequestHeadersWithFetchOptions().then(headers => {
            const authHeaders = getConnectedAccountHeaders(userIdentity);

            // Merge the connected account headers with the rest api request headers
            return authHeaders.then(authHeaders => {
                Object.keys(authHeaders).forEach(
                    headerName => (headers[headerName] = authHeaders[headerName])
                );

                return headers;
            });
        });
    }
    return Promise.resolve({});
}
